import React, { useState } from 'react';
import { CloseOutlined, SoundOutlined } from '@ant-design/icons';
import { useSiteSettings } from '../hooks/useSiteSettings';
import './AdTicker.css';

const TICKER_HIDDEN_KEY = 'ad_ticker_hidden_until';

const AdTicker = () => {
  const { ticker_enabled, ticker_text, ticker_duration_hours } = useSiteSettings();
  const [dismissed, setDismissed] = useState(false);

  const enabled = ticker_enabled === '1' || ticker_enabled === true;
  const text = (ticker_text || '').trim();

  if (!enabled || !text || dismissed) return null;

  try {
    const hiddenUntil = localStorage.getItem(TICKER_HIDDEN_KEY);
    if (hiddenUntil && Date.now() < Number(hiddenUntil)) return null;
  } catch (e) {
    /* ignore */
  }

  const durationHours = parseInt(ticker_duration_hours, 10);
  const hours = !isNaN(durationHours) && durationHours > 0 ? durationHours : 24;

  const handleClose = () => {
    setDismissed(true);
    try {
      localStorage.setItem(TICKER_HIDDEN_KEY, String(Date.now() + hours * 3600 * 1000));
    } catch (e) {
      /* ignore */
    }
  };

  return (
    <div className="ad-ticker">
      <div className="ad-ticker-content">
        <span className="ad-ticker-icon"><SoundOutlined /></span>
        <div className="ad-ticker-track">
          <div className="ad-ticker-text">{text}</div>
        </div>
        <button className="ad-ticker-close" onClick={handleClose} aria-label="إغلاق الإعلان">
          <CloseOutlined />
        </button>
      </div>
    </div>
  );
};

export default AdTicker;
